/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1DatalakeItem } from './V1DatalakeItem'
import {
    V1DatalakeItemFromJSON,
    V1DatalakeItemFromJSONTyped,
    V1DatalakeItemToJSON,
    V1DatalakeItemToJSONTyped
} from './V1DatalakeItem'

/**
 *
 * @export
 * @interface V1DatalakeItemList
 */
export interface V1DatalakeItemList {
    /**
     *
     */
    items?: Array<V1DatalakeItem>
}

/**
 * Check if a given object implements the V1DatalakeItemList interface.
 */
export function instanceOfV1DatalakeItemList(
    value: object
): value is V1DatalakeItemList {
    return true
}

export function V1DatalakeItemListFromJSON(json: any): V1DatalakeItemList {
    return V1DatalakeItemListFromJSONTyped(json, false)
}

export function V1DatalakeItemListFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1DatalakeItemList {
    if (json == null) {
        return json
    }
    return {
        items:
            json['items'] == null
                ? undefined
                : (json['items'] as Array<any>).map(V1DatalakeItemFromJSON)
    }
}

export function V1DatalakeItemListToJSON(json: any): V1DatalakeItemList {
    return V1DatalakeItemListToJSONTyped(json, false)
}

export function V1DatalakeItemListToJSONTyped(
    value?: V1DatalakeItemList | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        items:
            value['items'] == null
                ? undefined
                : (value['items'] as Array<any>).map(V1DatalakeItemToJSON)
    }
}
